import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "resend",
  "use": "resend-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"resend\"><path d=\"M376 288c0 70.688-57.312 128-128 128s-128-57.312-128-128c0-65.36 62.672-105.52 128-111.216V256l160-112v-16L248 0v80.672C130.448 87.584 24 169.648 24 288c0 123.712 100.288 224 224 224s224-100.288 224-224h-96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/resend.svg
// module id = ZD2b
// module chunks = 1